import { render, staticRenderFns } from "./CouponsEdit.vue?vue&type=template&id=61c31c72&"
import script from "./CouponsEdit.vue?vue&type=script&lang=js&"
export * from "./CouponsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports